export const NAVBAR_WIDTH = 66
